const mutations = {
  setModel(state, configurations) {

    state.model["max_installment_to_download"] = 12;
    configurations.forEach((item, key) => {
      state.model[item.key] = JSON.parse(item.value);
    });

    if (typeof state.model.per_installments === "string") {
      state.model.per_installments = JSON.parse(state.model.per_installments);
    }
  },
};

export default mutations;
